import * as React from 'react';
import styles from './index.less';
import img_banner from './assets/banner@3x.png';
import img_title from './assets/title@3x.png';
import img_reward from './assets/reward@2x.png';
import img_way from './assets/way@2x.png';
import img_standard from './assets/standard@2x.png';
import img_full from './assets/full@2x.png';
import img_inovation from './assets/inovation@2x.png';
import img_original from './assets/original@2x.png';
import img_spread from './assets/spread@2x.png';
import img_title2 from './assets/former.png';
import img_more from './assets/more.png';
import img_participation1 from './assets/participation1.png';
import img_participation2 from './assets/participation2.png';
import img_participation3 from './assets/participation3.png';
import img_awardSetting from './assets/awardSetting@3x.png';
import FFooter from '@/components/Footer';
import { ActivityDetailsPageModelState } from '@/models/activityDetailsPage';
import { connect } from 'dva';
import { ConnectState } from '@/models/connect';
import AboutUsMore from '../SpringFestival/AboutUsMore';
import img_NodeCover from './assets/default-node-cover.png';
import { FUtil, FI18n, FServiceAPI } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import Pick from './Pick';
import RuleModal from './RuleModal';
import Marquee from 'react-fast-marquee';
import Button from './Button';
import FComponentsLib from '@freelog/components-lib';
import dayjs from 'dayjs';
import fWeiXinShare from '@/components/fWeiXinShare';
import img_submit from './assets/submit@2x.png';
import img_share from './assets/share@2x.png';

interface EditorPickProps {
  activityDetailsPage: ActivityDetailsPageModelState;
}

interface INodeInfo {
  nodeLogo: string;
  nodeName: string;
  nodeTitle: string;
  ownerUserId: number;
  ownerUserName: string;
  nodeDomain: string;
}

function EditorPick({ activityDetailsPage }: EditorPickProps) {
  const ref_content1 = React.useRef<HTMLDivElement>(null);
  const ref_content2 = React.useRef<HTMLDivElement>(null);
  const ref_content3 = React.useRef<HTMLDivElement>(null);
  const ref_content4 = React.useRef<HTMLDivElement>(null);
  const ref_content5 = React.useRef<HTMLDivElement>(null);
  const ref_content6 = React.useRef<HTMLDivElement>(null);

  const ref_nodesInfo: React.RefObject<INodeInfo[]> = React.useRef<INodeInfo[]>([
    {
      nodeLogo:
        FUtil.Domain.IMAGE_ORIGIN + '/preview-image/2d1b2c74be3a3db2add8ed7cd1ff0a19f119d9ad.jpeg',
      nodeName: '游戏l攻略和二创',
      nodeTitle: '游戏',
      ownerUserId: 10146,
      ownerUserName: 'Eeyore',
      nodeDomain: 'spiel',
    },
    {
      nodeLogo:
        FUtil.Domain.IMAGE_ORIGIN + '/preview-image/a3570111e174760d6193118bd5ba55209065c33d.jpeg',
      nodeName: 'EM非常刑事案件',
      nodeTitle: '',
      ownerUserId: 10166,
      ownerUserName: 'BR',
      nodeDomain: 'emfcxsaj',
    },
    {
      nodeLogo:
        FUtil.Domain.IMAGE_ORIGIN + '/preview-image/69c8fce4e58b4f3ea3c204079de40cf5fdb0bf53.jpeg',
      nodeName: '太行道',
      nodeTitle: '申申菌漫画《太行道》',
      ownerUserId: 10119,
      ownerUserName: 'ssj',
      nodeDomain: 'ssj-comics03',
    },
  ]);
  const ref_testResourceIDs: React.RefObject<string[]> = React.useRef<string[]>([
    '6776554c529799002f8f929e',
    '61d6b5652ae3ac002eb85783',
    '6708d8866bb5eb00309ebfdb',
    '6788c73770270f002fe99fe1',
    '678d59eb1358ea002fe1df59',
  ]);

  const ref_resourceIDs: React.RefObject<string[]> = React.useRef<string[]>([
    // 第一期 小说/文章
    '65c239c134bae6002edac734',
    '65bf3acf34bae6002ed98a5a',
    // 第一期 漫画
    '653f6a0cb69047002e53af58',
    '6538e51fb69047002e531598',
    // 第一期 图片
    '65e084cf34bae6002edf8f1f',
    '65e58f4034bae6002edff156',
    '65d44c0a34bae6002edd34ab',
    '6553473db69047002e55de7c',
    '65e4643934bae6002edfd30e',
    '65bf36a334bae6002ed97ffc',
    '65bf3efb34bae6002ed9992a',
    '65dc341f34bae6002eded717',
    '65d851ee34bae6002ede6ebb',
    '6539e8feb69047002e535671',
    // 第一期 视频
    '65f0529d34bae6002ee04242',

    // 第二期 图片
    '662cc44e12f79d002edab526',
    '669cb46c228a3a0039721b03',
    '668407bf130d17002e00ec91',
    '66840823130d17002e00ecfc',
    '665426d7e266bf002ece37da',
    '6654269ae266bf002ece3754',
    '66503bd0e266bf002ece2a36',
    '664db7afe266bf002ece0df7',
    '664e9f98e266bf002ece1238',
    '66877fbb228a3a003971a1da',
    // 第二期 音频
    '662f0c8712f79d002edad986',
    '662f0b4112f79d002edad7d6',
    '662e044c12f79d002edac48c',
  ]);

  const [$isProdEnv, set$isProdEnv, get$isProdEnv] = FUtil.Hook.useGetState<boolean>(
    self.location.hostname.endsWith('.freelog.cn'),
  );

  const [$momentTime, set$momentTime, get$momentTime] =
    FUtil.Hook.useGetState<dayjs.Dayjs>(dayjs());
  const [$endTime, set$endTime, get$endTime] = FUtil.Hook.useGetState<dayjs.Dayjs>(
    dayjs(FI18n.i18nNext.tAuto('event_2024monthlyeditorspick_collect_date2')),
  );
  const [$announceTime, set$announceTime, get$announceTime] = FUtil.Hook.useGetState<dayjs.Dayjs>(
    dayjs(FI18n.i18nNext.tAuto('event_2024monthlyeditorspick_awards_date')),
  );
  const [$modalVisible_rule, set$modalVisible_rule, get$modalVisible_rule] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$modalVisible_award, set$modalVisible_award, get$modalVisible_award] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$resourceData, set$ResourceData, get$ResourceData] = FUtil.Hook.useGetState<
    {
      resourceId: string;
      coverImages: string;
      resourceTitle: string;
      resourceName: string;
      latestVersion: string;
      policies: {
        policyName: string;
      }[];
      userId: number;
      username: string;
    }[]
  >([]);
  const [$nodesInfo, set$nodesInfo] = FUtil.Hook.useGetState<INodeInfo[]>(
    ref_nodesInfo.current as INodeInfo[],
  );
  const [$isLogined, set$isLogined, get$isLogined] = FUtil.Hook.useGetState<boolean>(false);
  const [$isRegister, set$isRegister, get$isRegister] = FUtil.Hook.useGetState<boolean>(false);

  const [$direction, set$direction, get$direction] = FUtil.Hook.useGetState<'left' | 'right'>(
    'left',
  );

  const position = AHooks.useScroll(
    self.document.querySelector('#layout-content .simplebar-content-wrapper'),
  );

  const [$activated, set$activated, get$activated] = FUtil.Hook.useGetState<number>(1);

  AHooks.useDebounceEffect(
    () => {
      const info1 = ref_content1.current?.getBoundingClientRect();
      const info2 = ref_content2.current?.getBoundingClientRect();
      const info3 = ref_content3.current?.getBoundingClientRect();
      const info4 = ref_content4.current?.getBoundingClientRect();
      const info5 = ref_content5.current?.getBoundingClientRect();
      const info6 = ref_content6.current?.getBoundingClientRect();
      if (info6 && info6.top <= 72) {
        set$activated(6);
      } else if (info5 && info5.top <= 72) {
        set$activated(5);
      } else if (info4 && info4.top <= 72) {
        set$activated(4);
      } else if (info3 && info3.top <= 72) {
        set$activated(3);
      } else if (info2 && info2.top <= 72) {
        set$activated(2);
      } else {
        set$activated(1);
      }
    },
    [position],
    {
      wait: 100,
    },
  );

  function scrollTo(top: number) {
    self.document.querySelector('#layout-content .simplebar-content-wrapper')?.scrollBy({
      top,
      behavior: 'smooth',
    });
  }

  AHooks.useMount(async () => {
    if (FUtil.Tool.getUserIDByCookies() === -1) {
      return;
    }
    set$isLogined(true);
    const {
      data,
    }: {
      data: {
        userType: 0 | 1;
      };
    } = await FServiceAPI.User.currentUserInfo();
    set$isRegister(data.userType === 1);
  });

  function goResource(id: string) {
    window.open(
      FUtil.Format.completeUrlByDomain('console') +
        FUtil.LinkTo.resourceDetails({
          resourceID: id,
        }),
    );
  }

  function goNode(domain: string) {
    window.open('https://' + domain + '.freelog.cn');
  }

  AHooks.useMount(async () => {
    const { data }: any = await FServiceAPI.Resource.batchInfo({
      resourceIds: (get$isProdEnv()
        ? (ref_resourceIDs.current as string[])
        : (ref_testResourceIDs.current as string[])
      ).join(','),
    });
    set$ResourceData(data);
  });

  function commitWorks() {
    if (!get$isLogined()) {
      self.location.replace(
        FUtil.Format.completeUrlByDomain('user') +
          FUtil.LinkTo.login({
            goTo: self.location.href,
          }),
      );
      return;
    }
    if (!get$isRegister()) {
      // fCenterMessage({ message: '此活动仅对内测用户开放!' });
      self.open(FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.invitation());
      return;
    }
    self.open(FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.resourceCreatorEntry());
  }

  return (
    <>
      <div className={styles.editorPick}>
        <div className={styles.editorPickContainer}>
          <div style={{ width: '100%' }}>
            <img
              src={img_banner}
              alt=''
              style={{ width: '100%', aspectRatio: '240/149' }}
              fetchPriority={'high'}
              loading={'eager'}
            />
          </div>
          <div style={{ height: 80 }} />
          <div
            className={styles.editorPick1}
            style={{
              display: 'flex',
              flexFlow: 'column',
              position: 'relative',
              alignItems: 'center',
            }}
            ref={ref_content1}
          >
            <div>
              <img
                src={img_title}
                fetchPriority={'low'}
                loading={'lazy'}
                alt=''
                style={{ width: 353 }}
              />
            </div>
            <div style={{ height: 40 }} />
            <div
              style={{
                width: '100%',
                display: 'flex',
                position: 'relative',
                justifyContent: 'space-between',
                alignContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexFlow: 'column',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <span className={styles.editorPick1Title}>征集期</span>
                <div style={{ height: 32 }} />
                <span className={styles.editorPick1Content}>
                  {FI18n.i18nNext.tJSXElement(
                    FI18n.i18nNext.tAuto('event_2024monthlyeditorspick_collect_date'),
                  )}
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexFlow: 'column',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <span className={styles.editorPick1Title}>评选期</span>
                <div style={{ height: 20 }} />
                <span className={styles.editorPick1Content}>
                  {FI18n.i18nNext.tJSXElement(
                    FI18n.i18nNext.tAuto('event_2024monthlyeditorspick_selection_date'),
                  )}
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexFlow: 'column',
                  position: 'relative',
                }}
              >
                <span className={styles.editorPick1Title}>结果公示</span>
                <div style={{ height: 48 }} />
                <span className={styles.editorPick1Content}>
                  {FI18n.i18nNext.tJSXElement(
                    FI18n.i18nNext.tAuto('event_2024monthlyeditorspick_awards_date'),
                  )}
                </span>
              </div>
            </div>
            <div style={{ height: 50 }} />
            <div
              style={{
                display: 'flex',
                flexFlow: 'column',
                position: 'relative',
                alignItems: 'center',
              }}
              ref={ref_content2}
            >
              <span className={styles.editorPick1Title}>奖项设置</span>
              <div style={{ height: 20 }} />
              <img
                src={img_awardSetting}
                fetchPriority={'low'}
                loading={'lazy'}
                alt={''}
                style={{ width: 1100 }}
              />
              <div style={{ height: 30 }} />
              <div
                style={{
                  overflow: 'hidden',
                  display: 'flex',
                  flexFlow: 'row',
                }}
              >
                <img
                  src={img_reward}
                  fetchPriority={'low'}
                  loading={'lazy'}
                  alt=''
                  style={{ width: 656 }}
                />
              </div>
              <div style={{ height: 50 }} />
              <div
                className={styles.editorPick1Pub}
                style={{
                  display: 'flex',
                  flexFlow: 'column',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                {$momentTime.isAfter($announceTime) ? (
                  <Button
                    onClick={() => {
                      set$modalVisible_award(true);
                    }}
                    style={{
                      width: 230,
                      height: 54,
                    }}
                  >
                    查看获奖公示
                  </Button>
                ) : (
                  <>
                    本期获奖结果于 {FI18n.i18nNext.tAuto('event_2024monthlyeditorspick_awards_date')}{' '}
                    进行公示，敬请期待～
                  </>
                )}
              </div>
              <div style={{ height: 40 }} />
              <div
                className={styles.editorPick1Tip}
                style={{
                  display: 'flex',
                  flexFlow: 'column',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <div style={{ fontWeight: 600 }}>补充说明</div>
                <div>
                  已入选编辑精选的合集资源（含连载小说、漫画、音乐专辑、播客等），其内单个资源不再参与编辑精选评选；
                </div>
                <div>
                  作品须原创，严禁抄袭、代投、转载、重复投递，不接受任何形式的人工智能（AI）生成的作品；
                </div>
              </div>
            </div>
            <div style={{ height: 96 }} />
            <div
              style={{
                display: 'flex',
                flexFlow: 'column',
                position: 'relative',
                alignItems: 'center',
              }}
              ref={ref_content3}
            >
              <div>
                <img
                  src={img_way}
                  fetchPriority={'low'}
                  loading={'lazy'}
                  alt=''
                  style={{ width: 205 }}
                />
              </div>
              <div style={{ height: 46 }} />
              <div
                style={{
                  width: 'fit-content',
                  height: 'fit-content',
                  position: 'relative',
                }}
              >
                <img
                  src={img_participation1}
                  fetchPriority={'low'}
                  loading={'lazy'}
                  alt={''}
                  style={{ width: 1000, display: 'block' }}
                />
                <div
                  style={{
                    position: 'absolute',
                    right: 0,
                    bottom: 30,
                    left: 0,
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  {$isRegister && (
                    <Button
                      onClick={() => {
                        window.open(
                          FUtil.Format.completeUrlByDomain('console') +
                            FUtil.LinkTo.resourceCreatorEntry(),
                        );
                      }}
                      disabled={true}
                      style={{ width: 144, height: 44 }}
                    >
                      已获资格
                    </Button>
                  )}

                  {!$isRegister && (
                    <Button
                      onClick={async () => {
                        const {
                          data,
                        }: {
                          data: {
                            userType: 0 | 1;
                          };
                        } = await FServiceAPI.User.currentUserInfo();

                        if (FUtil.Tool.getUserIDByCookies() === -1) {
                          return;
                        }

                        self.open(
                          FUtil.Format.completeUrlByDomain('console') +
                            FUtil.LinkTo.invitation() +
                            '?type=apply',
                        );
                      }}
                      style={{ width: 144, height: 44 }}
                    >
                      提交内测申请
                    </Button>
                  )}
                </div>
              </div>
              <div style={{ height: 30 }} />
              <div
                style={{
                  width: 'fit-content',
                  height: 'fit-content',
                  position: 'relative',
                }}
              >
                <img
                  src={img_participation2}
                  fetchPriority={'low'}
                  loading={'lazy'}
                  alt={''}
                  style={{ width: 1000, display: 'block' }}
                />
                <div
                  style={{
                    position: 'absolute',
                    right: 0,
                    bottom: 30,
                    left: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 20,
                  }}
                >
                  <Button
                    onClick={() => {
                      self.open(
                        'https://freelog3.freelog.cn/?theme=%2Freader%3Fid%25M262ce6f8a456ff0002e32915f%25M1title%25M2%E4%B8%80%E3%80%81%E3%80%90%E5%8F%91%E8%A1%8C%E8%B5%84%E6%BA%90%E3%80%91%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97&w06c513=%2F',
                      );
                    }}
                  >
                    查看资源教程
                  </Button>
                  <Button
                    onClick={() => {
                      if (get$momentTime() > get$endTime()) {
                        return;
                      }
                      window.open(
                        FUtil.Format.completeUrlByDomain('console') +
                          FUtil.LinkTo.resourceCreatorEntry(),
                      );
                    }}
                    disabled={$momentTime > $endTime}
                  >
                    立即投稿
                  </Button>
                </div>
              </div>
              <div style={{ height: 30 }} />
              <div
                style={{
                  width: 'fit-content',
                  height: 'fit-content',
                  position: 'relative',
                }}
              >
                <img
                  src={img_participation3}
                  fetchPriority={'low'}
                  loading={'lazy'}
                  alt={''}
                  style={{ width: 1000, display: 'block' }}
                />
                <div
                  style={{
                    position: 'absolute',
                    right: 0,
                    bottom: 30,
                    left: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 20,
                  }}
                >
                  <Button
                    onClick={() => {
                      self.open(
                        'https://freelog3.freelog.cn/?theme=%2Freader%3Fid%25M262ce6f8a456ff0002e32915f%25M1title%25M2%E4%BA%8C%E3%80%81%E3%80%90%E8%BF%90%E8%90%A5%E8%8A%82%E7%82%B9%E3%80%91%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97&w06c513=%2F',
                      );
                    }}
                  >
                    查看节点教程
                  </Button>
                  <Button
                    onClick={async () => {
                      if (get$momentTime() > get$endTime()) {
                        return;
                      }
                      const {
                        data,
                      }: {
                        data: {
                          totalItem: number;
                          dataList: {
                            nodeId: number;
                          }[];
                        };
                      } = await FServiceAPI.Node.nodes({});
                      if (data.totalItem > 0) {
                        self.open(
                          FUtil.Format.completeUrlByDomain('console') +
                            FUtil.LinkTo.nodeManagement({
                              nodeID: data.dataList[0].nodeId,
                            }),
                        );
                      } else {
                        self.open(
                          FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.nodeCreator(),
                        );
                      }
                    }}
                    style={
                      $momentTime > $endTime
                        ? {
                            opacity: 0.4,
                            cursor: 'not-allowed',
                          }
                        : {
                            cursor: 'pointer',
                          }
                    }
                  >
                    运营节点
                  </Button>
                </div>
              </div>
              <div style={{ height: 40 }} />
              <FComponentsLib.FTextBtn
                onClick={() => {
                  set$modalVisible_rule(true);
                }}
              >
                查看活动规则
              </FComponentsLib.FTextBtn>
            </div>
            <div style={{ height: 96 }} />
            <div
              style={{
                display: 'flex',
                flexFlow: 'column',
                position: 'relative',
                alignItems: 'center',
              }}
              ref={ref_content4}
            >
              <div>
                <img
                  src={img_standard}
                  fetchPriority={'low'}
                  loading={'lazy'}
                  alt=''
                  style={{ width: 203 }}
                />
              </div>
              <div style={{ height: 45 }} />
              <div
                style={{
                  width: '100%',
                }}
              >
                <img
                  src={img_original}
                  fetchPriority={'low'}
                  loading={'lazy'}
                  alt=''
                  style={{ width: '100%' }}
                />
              </div>
              <div style={{ height: 36 }} />
              <div
                style={{
                  width: '100%',
                }}
              >
                <img
                  src={img_full}
                  fetchPriority={'low'}
                  loading={'lazy'}
                  alt=''
                  style={{ width: '100%' }}
                />
              </div>
              <div style={{ height: 36 }} />
              <div
                style={{
                  width: '100%',
                }}
              >
                <img
                  src={img_inovation}
                  fetchPriority={'low'}
                  loading={'lazy'}
                  alt=''
                  style={{ width: '100%' }}
                />
              </div>
              <div style={{ height: 36 }} />
              <div
                style={{
                  width: '100%',
                }}
              >
                <img
                  src={img_spread}
                  fetchPriority={'low'}
                  loading={'lazy'}
                  alt=''
                  style={{ width: '100%' }}
                />
              </div>
            </div>
            <div style={{ height: 101 }} />
            <div
              style={{
                display: 'flex',
                flexFlow: 'column',
                position: 'relative',
                alignItems: 'center',
                width: '100%',
              }}
              ref={ref_content5}
            >
              <div>
                <img
                  src={img_title2}
                  fetchPriority={'low'}
                  loading={'lazy'}
                  alt=''
                  style={{ width: 427 }}
                />
              </div>
              <div style={{ height: 47 }} />
              <div className={styles.showContainer}>
                <Marquee
                  direction={$direction}
                  autoFill={true}
                  pauseOnHover={true}
                  speed={100}
                  onCycleComplete={() => {
                    // console.log('Cycle complete!');
                    set$direction(get$direction() === 'left' ? 'right' : 'left');
                  }}
                  onFinish={() => {}}
                >
                  <div className={styles.carContainer}>
                    {$resourceData.map((item, index, arr) => {
                      return (
                        <div
                          key={item.resourceId}
                          className={
                            styles.card +
                            ' ' +
                            (arr.length > 3 && index > 2 ? styles.marginT : '') +
                            ' ' +
                            ((index + 1) % 3 !== 0 && index !== arr.length - 1
                              ? styles.marginR
                              : '')
                          }
                        >
                          <div className={styles.cardInfo}>
                            <div className={styles.img} onClick={() => goResource(item.resourceId)}>
                              <img
                                src={item.coverImages}
                                fetchPriority={'low'}
                                loading={'lazy'}
                                alt=''
                              />
                            </div>
                            <div
                              className={styles.carTitle}
                              onClick={() => goResource(item.resourceId)}
                            >
                              {item.resourceTitle || item.resourceName.split('/')[1]}
                            </div>
                            <div
                              className={
                                styles.resourceInfo + ' flex-row space-between align-center mt-8'
                              }
                            >
                              <span className={styles.resourceName}>
                                {item.resourceName.split('/')[1]}
                              </span>
                              <span>最新版本{' ' + item.latestVersion}</span>
                            </div>
                            <div className={styles.policy}>
                              {item.policies.map((p: any) => {
                                return <span key={p.policyName}>{p.policyName}</span>;
                              })}
                            </div>
                          </div>

                          <div className={styles.personInfo}>
                            <div className={styles.avatar}>
                              <img
                                src={FUtil.Domain.IMAGE_ORIGIN + `/avatar/${item.userId}`}
                                fetchPriority={'low'}
                                loading={'lazy'}
                                alt=''
                              />
                            </div>
                            <div className={styles.name}>{item.username}</div>
                            <div className={styles.reward} />
                          </div>
                        </div>
                      );
                    })}
                    {$nodesInfo.map((item, index, arr) => {
                      return (
                        <div
                          key={index}
                          className={
                            styles.card +
                            ' ' +
                            (arr.length > 3 && index > 2 ? styles.marginT : '') +
                            ' ' +
                            ((index + 1) % 3 !== 0 && index !== arr.length - 1
                              ? styles.marginR
                              : '')
                          }
                        >
                          <div className={styles.cardInfo}>
                            <div
                              className={' ' + styles.nodeImg}
                              onClick={() => goNode(item.nodeDomain)}
                            >
                              <div className={styles.nodeLogo}>
                                <img
                                  src={item.nodeLogo || img_NodeCover}
                                  fetchPriority={'low'}
                                  loading={'lazy'}
                                  alt=''
                                />
                              </div>
                              <div className={styles.nodeInfo}>
                                <div className={styles.nodeTitle}>
                                  {item.nodeTitle || item.nodeName}
                                </div>
                                <div className={styles.nodeDomain + ' link'}>
                                  {item.nodeDomain + '.freelog.cn'}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className={styles.personInfo}>
                            <div className={styles.avatar}>
                              <img
                                src={FUtil.Domain.IMAGE_ORIGIN + `/avatar/${item.ownerUserId}`}
                                fetchPriority={'low'}
                                loading={'lazy'}
                                alt=''
                              />
                            </div>
                            <div className={styles.name}>{item.ownerUserName}</div>
                            <div className={styles.reward} />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Marquee>
              </div>
            </div>
            <div style={{ height: 80 }} />
            <div>
              <img
                src={img_more}
                fetchPriority={'low'}
                loading={'lazy'}
                alt=''
                style={{ width: 237 }}
              />
            </div>
          </div>
          <div style={{ height: 40 }} />
          <AboutUsMore />
          <div style={{ height: 80 }} />
        </div>
        <RuleModal
          open={$modalVisible_rule}
          onCancel={() => {
            set$modalVisible_rule(false);
          }}
        />
        <Pick
          visible={$modalVisible_award}
          onCancel={() => {
            set$modalVisible_award(false);
          }}
        />
        <FFooter />

        <div className={styles.navs}>
          <a
            className={$activated === 1 ? styles.activated : ''}
            onClick={() => {
              const info = ref_content1.current?.getBoundingClientRect();
              scrollTo((info?.top || 0) - 70);
            }}
          >
            活动日程
          </a>
          <div />
          <a
            className={$activated === 2 ? styles.activated : ''}
            onClick={() => {
              const info = ref_content2.current?.getBoundingClientRect();
              scrollTo((info?.top || 0) - 70);
            }}
          >
            活动奖励
          </a>
          <div />
          <a
            className={$activated === 3 ? styles.activated : ''}
            onClick={() => {
              const info = ref_content3.current?.getBoundingClientRect();
              scrollTo((info?.top || 0) - 70);
            }}
          >
            参与方式
          </a>
          <div />
          <a
            className={$activated === 4 ? styles.activated : ''}
            onClick={() => {
              const info = ref_content4.current?.getBoundingClientRect();
              scrollTo((info?.top || 0) - 70);
            }}
          >
            评选标准
          </a>
          <div />
          <a
            className={$activated === 5 ? styles.activated : ''}
            onClick={() => {
              const info = ref_content5.current?.getBoundingClientRect();
              scrollTo((info?.top || 0) - 70);
            }}
          >
            往期精选
          </a>
        </div>
      </div>

      <div
        className={styles.submit}
        onClick={() => {
          commitWorks();
        }}
      >
        <img loading={'eager'} fetchPriority={'high'} src={img_submit} alt='提交作品' />
      </div>

      <div
        className={styles.share}
        onClick={() => {
          fWeiXinShare({
            configs: {
              title: activityDetailsPage.pageTitle,
              desc: activityDetailsPage.description,
              link: self.location.href,
              imgUrl: activityDetailsPage.cover,
            },
          });
        }}
      >
        <img loading={'eager'} fetchPriority={'high'} src={img_share} alt='分享活动' />
      </div>
    </>
  );
}

export default connect(({ activityDetailsPage }: ConnectState) => ({
  activityDetailsPage,
}))(EditorPick);
